/* eslint-disable react/button-has-type */
/* eslint-disable jsx-a11y/media-has-caption */
import CloseIcon from '@mui/icons-material/Close';
import SendIcon from '@mui/icons-material/Send';
import { IMessageInputModel } from 'inputModels';
import { Fragment, useState } from 'react';
import { serialize } from 'object-to-formdata';
import { useForm, useWatch } from 'react-hook-form';
import Modal from 'react-modal';
import { AudioRecorder } from 'react-audio-voice-recorder';
import { IMessageViewModel } from 'viewModels';
import { v4 as uuid } from 'uuid';
import { useAuth } from '../../../context';
import { useConversation } from '../../../context/conversation';
import ConversationController from '../../../controller/ConversationController';
import { MessageType } from '../../../types/enums';
import { Conversation } from '../../Conversation';
import { Input } from '../../Inputs/Input';
import { ContentModal, Header } from './styles';
import { Tooltip } from '@mui/material';

interface ChatProps {
  isOpen: boolean;
  onRequestClose: () => void;
  conversationId?: string;
  zIndex?: number;
}
export function ModalChat({ isOpen, conversationId, onRequestClose, zIndex }: ChatProps) {
  const { conversations, setActiveConversationId, setConversations } = useConversation();
  const { user } = useAuth();
  const [defaultValues] = useState({
    messageText: '',
    messageVoice: null,
  });
  const [sendedMessage, setSendedMessage] = useState(false);
  const [recordedAudioBlob, setRecordedAudioBlob] = useState<Blob | null>(null);

  const handleSendMessage = () => {
    if (!conversationId) return;
    setActiveConversationId(conversationId);
    const message: IMessageInputModel = {
      text: text || '',
      type: text ? MessageType.TEXT : MessageType.AUDIO,
      conversationId,
    };
    const formData = serialize(message, { indices: true });

    if (text) {
      ConversationController.sendMessage(formData).then(() => {
        setValue('messageText', '');
        setSendedMessage(!sendedMessage);
        setConversations((prev) => {
          const newConversation = [...prev];
          const conversationIndex = newConversation.findIndex(
            (c) => c.id === message.conversationId,
          );
          if (conversationIndex !== -1) {
            const newMessage: IMessageViewModel = {
              text: message.text || '',
              conversationId: message.conversationId,
              attachment: message.attachments,
              createdAt: new Date(),
              createdById: user.id,
              messageType: message.type,
            };
            newConversation[conversationIndex].messages.push(newMessage);
          }
          return newConversation;
        });
      });
    }

    if (recordedAudioBlob) {
      formData.append('attachment', recordedAudioBlob, 'audio.webm');

      ConversationController.sendMessage(formData).then(() => {
        setRecordedAudioBlob(null);
        setSendedMessage(!sendedMessage);
      });
    }
  };

  const handleReadMessages = () => {
    if (conversationId) {
      const hasUnreadMessage = conversations
        .find((c) => c.id === conversationId)
        ?.messages.some((m) => m.infos?.some((i) => i.createdById === user.id && !i.isReaded));
      if (hasUnreadMessage) ConversationController.readMessages(conversationId);
    }
  };

  const { control, setValue } = useForm({ defaultValues });

  const [text] = useWatch({
    control,
    name: ['messageText'],
  });

  const handleAudioRecordingComplete = (blob: Blob) => {
    setRecordedAudioBlob(blob);
  };
  const setZIndex =
    zIndex !== undefined
      ? {
          overlay: {
            zIndex,
          },
        }
      : {};

  const showComma = (idx: number) => {
    const length =
      conversations
        .find((c) => c.id === conversationId)
        ?.participants.filter((p) => p.id !== user.id).length || 0;
    if (length <= 1) return '';
    if (idx === length - 2) return 'e';
    if (idx < length - 1) {
      return ', ';
    }
    return '';
  };

  const getNameParticipant = () => {
    const names = conversations
      .filter((c) => c.id === conversationId)
      .flatMap((conversation) =>
        conversation.participants
          .filter((p) => p.id !== user.id)
          .map((participant) => {
            return `${participant?.firstName ? participant.firstName.trim() : ''} 
            ${participant?.lastName ? participant.lastName.trim() : ''}`;
          }),
      );
    return names.filter((value, index, self) => self.indexOf(value) === index);
  };

  return (
    <Modal
      style={setZIndex}
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      overlayClassName="react-modal-overlay"
      className="react-chat-modal-content">
      <Header>
        <div className="subHeader">
          {getNameParticipant().map((name, idx) => (
            <Fragment key={name + uuid()}>
              <Tooltip title={name}>
                <h1>{name}</h1>
              </Tooltip>
              <h1>{showComma(idx)}</h1>
            </Fragment>
          ))}
        </div>
        <div className="close-div">
          <button type="button" onClick={onRequestClose}>
            <CloseIcon fontSize="small" />
          </button>
        </div>
      </Header>
      <ContentModal>
        <Conversation conversationId={conversationId} scroll={sendedMessage} />
        <div className="sendMessage">
          {!recordedAudioBlob ? (
            <Input
              name="messageText"
              control={control}
              autoComplete="off"
              placeholder="Digite sua mensagem"
              onClick={handleReadMessages}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  handleSendMessage();
                }
              }}
              style={{ border: 'none' }}
            />
          ) : (
            <div className="recorded-audio">
              <audio controls src={URL.createObjectURL(recordedAudioBlob)} />
              <button
                onClick={() => {
                  setRecordedAudioBlob(null);
                }}>
                excluir
              </button>
            </div>
          )}
          <div className="audio">
            <AudioRecorder
              onRecordingComplete={handleAudioRecordingComplete}
              audioTrackConstraints={{
                noiseSuppression: true,
                echoCancellation: true,
              }}
              showVisualizer
              classes={{
                AudioRecorderClass: 'audio-recorder',
                AudioRecorderDiscardClass: 'audio-recorder-discard',
              }}
            />
          </div>
          <div className="icons">
            <button type="button" onClick={handleSendMessage}>
              <SendIcon />
            </button>
          </div>
        </div>
      </ContentModal>
    </Modal>
  );
}
